<template>
  <div>
    <el-button type="primary" class="addBtn" @click="addBtnClick"
      >新增合作伙伴</el-button
    >
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="sort" label="权重" align="center" width="60">
        </el-table-column>

        <el-table-column label="pc端图片" align="center">
          <template slot-scope="scope">
            <img :src="imgDomain + scope.row.icon" class="project-img" />
          </template>
        </el-table-column>
				<el-table-column label="h5端图片" align="center">
          <template slot-scope="scope">
            <img :src="imgDomain + scope.row.h5_icon" class="project-img" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="公司名称"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="opration-item" @click="editClientClick(scope.row)"
                >编辑</span
              >
              <span class="opration-item" @click="deleteServiceClick(scope.row)"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <common-dialog
      title="删除轮播图"
      :dialogVisible="dialogVisible"
      @cancel="dialogCancelClick"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        是否删除合作伙伴？
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonDialog from "@/components/CommonDialog";
import { getPartnerList, deletePartner } from "@/api/partner";

export default {
  name: "slideimgmanage",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      handle_row: {},
    };
  },
  computed: {
    ...mapState(["imgDomain"]),
  },
  mounted() {
    this._getPartnerList();
  },
  components: {
    CommonDialog,
  },
  methods: {
    addBtnClick() {
      if (this.tableData.length === 0) {
        this.$router.push("/clienthandle");
      } else {
        this.$message({
          type: "warning",
          message: "只能上传一张图片",
        });
      }
    },
    async _getPartnerList() {
      const { data, status } = await getPartnerList();
      if (status !== 200) return;
      console.log(data, "partenr list");
      this.tableData = data.data;
    },
    deleteServiceClick(row) {
      this.handle_row = row;
      this.dialogVisible = true;
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    dialogClose() {
      this._getPartnerList();
      this.handle_row = {};
    },
    async dialogConfirmClick() {
      const { status } = await deletePartner(this.handle_row.uuid);
      if (status !== 200) return;
      this.dialogVisible = false;
    },
    editClientClick(row) {
      this.$router.push({
        path: "/clienthandle",
        query: {
          uuid: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
}
.table-wrap {
  margin-bottom: 40px;
  .project-img {
    width: 100%;
    max-height: 400px;
  }
}
.operation-wrap {
  display: flex;
  justify-content: space-around;
  color: @color-text;
  .opration-item {
    cursor: pointer;
  }
}
.dialog-body-wrap {
  text-align: center;
}
</style>
